import ownerWindow from '@mui/utils/ownerWindow';
export default ownerWindow;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/utils/ownerWindow.js
// module id = 261
// module chunks = 22